import Amount from '@components/common/molecules/Amount';
import Food from '@components/offer/models/Food';
import { Box, ButtonBase, Divider, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import SideDishListAndNote from './SideDishListAndNote';
import OrderFoodRequest from '@components/order/models/edit/OrderFoodRequest';
import FoodQuantityNumber from './OrderFoodQuantityNumber';

interface OrderFoodListItemProps {
    orderFood: OrderFoodRequest;
    actions?: JSX.Element;
}

const OrderFoodListItem: React.FC<OrderFoodListItemProps> = observer(({ orderFood, actions = undefined }) => {

    return (
        <>
            <ListItem sx={{ pt: 0.5, pb: 0 }}>
                <Box width={"100%"}>
                    <ListItemText
                        primary={
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={0.5}>
                                <FoodQuantityNumber orderFood={orderFood} />
                                <Typography width={"100%"}>{orderFood.food.name}</Typography>
                            </Box>
                        }
                        secondary={<SideDishListAndNote orderFood={orderFood} />}
                    />
                    <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                        <Amount
                            amount={orderFood.totalAmount}
                            color={"secondary"}
                            variant='subtitle2' />
                        <Box flexGrow={1} />
                        {actions && actions}
                    </Box>
                    <Divider />
                </Box>
            </ListItem>
        </>
        // <ButtonBase
        //     sx={{
        //         p: 1,
        //         pb: 0,
        //         width: "100%",
        //         textAlign: "left",
        //         alignItems: "flex-start",
        //         justifyContent: "flex-start",
        //         ":hover": {
        //             bgcolor: (theme) => theme.palette.secondary.light
        //         }
        //     }}>
        //     <Box width={"100%"}>
        //         <Box display={"flex"} flexDirection={"row"}>
        //             <FoodQuantityNumber orderFood={orderFood} />
        //             <Box
        //                 display={"flex"}
        //                 flexDirection={"column"}
        //                 width={"100%"}
        //                 alignItems={"flex-start"}
        //                 flexGrow={1}
        //                 ml={0.5}>
        //                 <Typography width={"100%"}>{orderFood.food.name}</Typography>
        //                 <SideDishList orderFood={orderFood} />
        //                 <Amount
        //                     amount={orderFood.totalAmount}
        //                     mt={0.5}
        //                     variant='caption'
        //                     fontWeight={600}
        //                     color={"secondary"} />
        //             </Box>
        //             {actions && actions}
        //         </Box>
        //         <Divider />
        //     </Box>
        // </ButtonBase>
    )
})

export default OrderFoodListItem;